@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.voiceassistant

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.models.voiceassistant.VoiceAssistantField
import com.narbase.letsgo.web.models.voiceassistant.VoiceAssistantMediumConfidenceAction
import com.narbase.letsgo.web.models.voiceassistant.VoiceAssistantSpeechDetector

object StartVoiceAssistantSessionEndpoint :
    EndPoint<StartVoiceAssistantSessionEndpoint.Request, StartVoiceAssistantSessionEndpoint.Response>() {
    class Request(
        @Suppress("NON_EXPORTABLE_TYPE") val field: DtoName<VoiceAssistantField>,
        val existingSessionId: String?,
        val passengerLat: Double?,
        val passengerLng: Double?,
    )

    class Response(
        val sessionId: String,
        val introAudioUrl: String?,
        val maxRecordingSeconds: Int,
        @Suppress("NON_EXPORTABLE_TYPE") val speechDetector: DtoName<VoiceAssistantSpeechDetector>,
        val silenceSecondsBeforeSend: Int?,
        val isRecordingTimerStartedOnSpeech: Boolean,
        val isSilencedMicrophoneDetected: Boolean,
        val isRouteConfirmationSkippedOnHighConfidence: Boolean,
        @Suppress("NON_EXPORTABLE_TYPE") val mediumConfidenceAction: DtoName<VoiceAssistantMediumConfidenceAction>,
        @Suppress("NON_EXPORTABLE_TYPE") val lowConfidenceAction: DtoName<VoiceAssistantMediumConfidenceAction>,
        val isAvailable: Boolean,
        val isRideBookedOnRouteConfirmation: Boolean? = null,
    )
}
